import React from "react"
import { Route, Routes } from "react-router-dom"
import { View404 } from "../views/systemPages/View404.view"
import { useSession } from "../hooks/auth/useSession.hook"
import { getRoutesByRole } from "../utils/routes.utils"
import { DEFAULT_ROUTES } from "./roleRoutes/defaultRoutes.routes"
import { AppRoutes } from "../consts/appRoutes.consts"
import QuickEstimationsV3 from "../views/estimations/agent/chat/quick-v3/QuickEstimationsV3"

// TODO: temporal — acceso al chat de estimaciones para un usuario concreto
const ESTIMATION_AGENT_ACCESS_USER_ID = 28

export function ApplicationRoutes() {
  const { user } = useSession()
  const routes = getRoutesByRole(user?.projectRole)
  const hasEstimationRoute = routes.some(
    (route) => route.path === AppRoutes.estimations.agent.chat
  )

  const toRoute = ({ path, element }) => (
    <Route key={path} path={path} element={element} />
  )

  return (
    <Routes>
      {/* User's specific routes */}
      {routes.map(toRoute)}

      {user?.id === ESTIMATION_AGENT_ACCESS_USER_ID && !hasEstimationRoute && (
        <Route
          path={AppRoutes.estimations.agent.chat}
          element={<QuickEstimationsV3 />}
        />
      )}

      {/* Routes for all users, no matter role */}
      {DEFAULT_ROUTES.map(toRoute)}

      {/* 404 */}
      <Route path="*" element={<View404 />} />
    </Routes>
  )
}
